import React from 'react';
import CustomizedMarker from './CustomizedMarker'
import { Timeline } from "primereact/timeline";

function TimelineSeplag({ customizedContent, logs }) {


  return <Timeline
    value={logs}
    align="alternate"
    className="customized-timeline"
    content={(item) => customizedContent(item)}
    marker={(item) => CustomizedMarker(item)}
  />;
}

export default TimelineSeplag;